// Functions
	function titleWaypoints (title) {
		if (title.classList.contains('blind-text')) title.parentElement.classList.add('active');
		if (title.querySelector('.blind-text')) title.classList.add('active');
	}


// Execution
	$(document).ready(() => {
		// Title management
			$('.blind-text').each(function () {
				// if ($('body').hasClass('page--contact')) return;
				if ($(this).parents('.waypoint').length) return;

				const el = this;

				new Waypoint({
					element: el,
					handler: function () {
						titleWaypoints(el);
						this.destroy();
					},
					offset: el.dataset.waypointOffset || '70%'
				});
			});

		// General Waypoint management for each "waypoint" class
			$('.waypoint').each(function () {
				const el = this;

				if ($(el).data('waypoint-manual') !== undefined) return; // Prevent this automatic waypoint to execute and do whatever elsewhere manually

				new Waypoint({
					element: el,
					handler: function () {
						$(el).removeClass('waypoint');

						$(el).find('h1, h2').each((i, e) => titleWaypoints(e) );

						if (el.dataset.waypointKeepalive !== undefined) this.destroy();
					},
					offset: el.dataset.waypointOffset || '65%'
				});
			});

			$('.card.waypoint').each(function () {
				const el = this;
				const width = screen.width;
				let offset = "95%";

				if (width < 1025) {
					offset = '90%'
				} else {
					offset = '92%'
				}

				new Waypoint({
					element: el,
					handler: function () {
						$(el).removeClass('waypoint');

						$(el).find('h3').each((i, e) => titleWaypoints(e) );

						if (el.dataset.waypointKeepalive !== undefined) this.destroy();
					},
					offset: el.dataset.waypointOffset || offset
				});
			});


		// Old stuff (but functioning)
			$('.project').each(function(){
				var project = this;
				var waypoint = new Waypoint({
					element: this,
					handler: function() {
						$(project).find('.case-links').toggleClass("text-appear");
						this.destroy();
					},
					offset: '65%'
				});
			});

			$('.clients').each(function(){
				var client = this;
				var waypoint = new Waypoint({
					element: this,
					handler: function() {
						$(client).find('.carousel-el').toggleClass("logo-appear");
						this.destroy();
					},
					offset: '75%'
				});
			});

			$('.moulinex--intro').each(function(){
				var waypoint = new Waypoint({
					element: this,
					handler: function() {
						$('.moulinex--intro > h1').toggleClass("appear-bottom");
						$('.moulinex--intro > p').toggleClass("appear-bottom");
						this.destroy();
					},
					offset: '100%'
				});
			});

			$('.moulinex--carrousel').each(function(){
				var waypoint = new Waypoint({
					element: this,
					handler: function() {
						$('.moulinex--carrousel > img').toggleClass("appear-bottom");
						this.destroy();
					},
					offset: '75%'
				});
			});

			$('.moulinex--illu').each(function(){
				var moulinexillu = this;
				var waypoint = new Waypoint({
					element: this,
					handler: function() {
						$(moulinexillu).find('.wrap-img').toggleClass("swipe-overlay");
						this.destroy();
					},
					offset: '50%'
				});
			});



		// Clients page / Works clients page
			// Default (to all clients)
				(() => {
					if (!$('body').hasClass('page--client')) return;

					$('.briefing .waypoint').each(function () {
						const el = this;

						new Waypoint({
							element: el,
							handler: function () {
								$(el).find('.blind-text').each(function (i, e) {
									setTimeout(function () {
										titleWaypoints(e);
									}, i * 250);
								});

								this.destroy();
							},
							offset: '75%'
						});
					});
				})();



		// Contact page
			/*(() => {
				if (!document.querySelector('body').classList.contains('page--contact')) return false;

				// Step 1, autolaunch
					document.querySelector('.intro p').classList.add('active');

					setTimeout(function () {
						document.querySelector('.intro p').classList.remove('active');

						setTimeout(function () {
							document.querySelector('.intro p').classList.add('hide');
							document.querySelector('.intro h1').classList.remove('hide');
							document.querySelector('.intro h1').classList.add('active');

							// Launch step 2
						}, 1000);
					}, 2000);
			})();*/

			/*(() => { // Temporarily cancelled
				if (!document.querySelector('body').classList.contains('page--contact')) return false;
				const form = document.querySelector('.contact-form');
				const lines = form.querySelectorAll('li');
				const steps = [];

				let currentIndex = 0;
				const duration = window.getComputedStyle(document.querySelector('.blind-text')).transitionDuration.match(/[0-9.]+/)[0] * 1000;

				// functions per step
					function toNext () {
						lines[currentIndex].classList.remove('active');

						setTimeout(() => {
							lines[currentIndex].classList.add('hide');

							//// New currentIndex value
							currentIndex++;
							lines[currentIndex].classList.remove('hide');
							setTimeout(() => { lines[currentIndex].classList.add('active') }, 25);

							setTimeout(() => {
								if (lines[currentIndex].querySelector('input, textarea')) {
									lines[currentIndex].querySelector('input, textarea').focus();
								}
							}, duration);
						}, duration);
					}

					// steps[0] = function (index) {
					// 	lines[index].classList.add()
					// }

				// 1 ———— Autolaunch
					lines[currentIndex].classList.add('active');

				// 2 ———— Calling for attention
					setTimeout(toNext, 2000);

				// 3 ———— Clicked Yes
					form.querySelector('.proceed').addEventListener('click', function (e) {
						e.preventDefault();

						toNext();

						form.classList.add('proceeding');
					});

				// Listeners and their actions
					for (let i = 0; i < lines.length; i++) {
						if (!lines[i].querySelector('input')) continue;

						lines[i].querySelector('input').addEventListener('keypress', function (e) {
							console.log(e);
							if (e.key == 'Enter') {
								e.preventDefault();

								if (i == lines.length - 1) {
									form.classList.add('complete');
									form.submit();
								}

								this.blur();

								toNext();
							}
						});
					}
			})();*/
	});